import luUploadFile from "./src/lu-upload-file";

luUploadFile.install = function(Vue) {
  Vue.component(luUploadFile.name, luUploadFile);
};

export default luUploadFile;
